import { SALARY_REQUEST } from '../actions/utilities';

const INITIAL_STATE = {
    getSalaryLoading: false,
    getSalarySuccess: false,
    getSalaryFailure: false,
    getSalaryError: null,
    salaryList: [],
}

export const salaryReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SALARY_REQUEST.GET_SALARY_REQUEST:
            return {
                ...state,
                getSalaryLoading: true,
                getSalarySuccess: false,
                getSalaryFailure: false,
                getSalaryError: null
            }
        case SALARY_REQUEST.GET_SALARY_SUCCESS:
            return {
                ...state,
                getSalaryLoading: false,
                getSalarySuccess: true,
                getSalaryFailure: false,
                getSalaryError: null,
                salaryList: action.payload
            }
        case SALARY_REQUEST.GET_SALARY_FAILURE:
            return {
                ...state,
                getSalaryLoading: false,
                getSalarySuccess: false,
                getSalaryFailure: true,
                getSalaryError: action.payload
            }
        default:
            return state;
    }
}